import { GameUI } from "game/gameUI/GameUI"
import { translate } from "game/translate"
import { Popups } from "ui/types/popups"

export const OutMoveWandPopup = () => {
    return (
        <div id="out-move-wand" role="tooltip" className="nomoves_wand modals_area active">
            <div className="wrapper">
                <button type="button" className="close_btn close" onClick={() => GameUI.closePopup(Popups.OUT_MOVE_WAND_POPUP)}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("nomoves_wand_title")}</span>
                    <img className="modals_area_img" src="/assets/magic_wand_modals/magic_wand_img_3.webp" />
                    <p className="modals_area-text">{translate("nomoves_wand_text")}</p>
                    <button type="button" className="modals_area-btn" onClick={() => GameUI.closePopup(Popups.OUT_MOVE_WAND_POPUP, true)}>{translate("nomoves_wand_btn")}</button>
                </div>
            </div>
        </div>
    )
}